import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import styled from 'styled-components';

import { CommunityContract } from 'types/contracts';

import { AccommodationContext } from './AccommodationContext';
import AccommodationGroupCollapse from './AccommodationGroupCollapse';
import AccommodationOccupancy from './AccommodationOccupancy';
import Header from '../../common/header/Header';
import { useCareTypesContext } from '../CareTypesContext';
import { LivingInfoDataType, LivingInfoGroupedDataType } from '../types';

const Container = styled.div`
  box-sizing: border-box;
  position: relative;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Accommodation = () => {
  const { competitorId } = useParams();
  const { communityId } = useParams();
  const { careType, contract } = useCareTypesContext();
  const livingInfoData = careType?.livingInfo;

  const id = Number(competitorId || communityId);
  const [contractLivingInfoData, setContractLivingInfoData] = useState<LivingInfoGroupedDataType[]>([]);

  useEffect(() => {
    const filteredLivingInfoData = livingInfoData
      ?.map((group: LivingInfoGroupedDataType) => {
        // Filter apartments by the target contract ID
        const filteredApartments = group.apartments.filter((item: LivingInfoDataType) =>
          (item?.contracts || []).some((contractItem: CommunityContract) => contractItem.id === contract?.id)
        );

        // Only keep groups that have at least one matching apartment
        return {
          ...group,
          apartments: filteredApartments.length > 0 ? filteredApartments : [],
        };
      })
      .filter((group) => group.apartments.length);

    setContractLivingInfoData(filteredLivingInfoData ?? []);
  }, [contract, careType, livingInfoData]);

  if (!contractLivingInfoData?.length) {
    return null;
  }

  return (
    <AccommodationContext.Provider
      value={{
        livingInfoData: contractLivingInfoData,
      }}
    >
      <Container>
        <Header title="Accommodation" controls={<AccommodationOccupancy />} />
        <Content>
          <AccommodationGroupCollapse />
        </Content>
      </Container>
    </AccommodationContext.Provider>
  );
};

export default Accommodation;
